var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.isComponent
        ? _c(_vm.isComponent, {
            tag: "component",
            staticClass: "content",
            attrs: {
              "view-bindings": _vm.viewBindings,
              filestore: _vm.filestore,
              widget: _vm.widget,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }